import 'devextreme/dist/css/dx.common.css';
import './themes/generated/theme.base.dark.css';
import './themes/override/theme.base.dark.override.css';
import './themes/generated/theme.base.css';
import './themes/override/theme.base.override.css';
import './themes/generated/theme.additional.dark.css';
import './themes/generated/theme.additional.css';
import { createApp }  from "vue";
import router from "./router";
import themes from "devextreme/ui/themes";

import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import { createPinia } from "pinia";
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

import ClassifierDataGrid from "@/components/classifier/ClassifierDataGrid.vue";

import { en } from "@/locales/en";
import { lv } from "@/locales/lv";
//import { ru } from "@/locales/ru";
import { createI18n } from "vue-i18n";
const i18n = createI18n({
  legacy: false,
  allowComposition: true,
  locale: "lv",
  globalInjection: true,
  fallbackLocale: "lv",
  messages: {
    en: en,
    lv: lv,
//    ru: ru,
  },
});

import App from "./App";
import appInfo from "./app-info";

import config from "devextreme/core/config";
import { licenseKey } from './dx-key';
config({ licenseKey });

themes.initialized(() => {
    const app = createApp(App);
    app.use(pinia);
    app.use(router);
    app.use(i18n);
    app.component("ClassifierDataGrid", ClassifierDataGrid);
    app.config.globalProperties.$appInfo = appInfo;
    app.mount('#app');
});
